export default __webpack_public_path__ + "static/media/British_Eventing.e7fa5b22.jpg";